import { booleanFieldConfig } from 'src/config/tables';
import type { Filter } from '..';
import Select from 'src/components/Table/filters/Select';

const BooleanFilter: Filter = Select({ options: booleanFieldConfig });

export default BooleanFilter;
